export const WORK_ORDER_ROUTES = {
  list: '/staff/work-orders',
  detail: '/staff/work-orders/:id',
} as const;
